<template>
  <div>
    <div v-if="isShow" class="showModal">
      <div class="modal-title">MiReportor</div>
      <div class="modal-desc">医学影像报告生成系统</div>
      <div class="flexRow beta2">
        <div class="beta" @click="openIndex">DEMO</div>
        <div class="beta" @click="openView">BETA</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isShow: true
    };
  },
  methods: {
    openIndex() {
      this.isShow = false;
      // localStorage.removeItem("name");
      // localStorage.removeItem("id");
      // localStorage.setItem("token", "xxx");
      localStorage.setItem("pageType", "demo");
      setTimeout(() => {
        this.$router.push("/index");
        this.$router.go();
      }, 200);
    },
    openView() {
      // if (localStorage.getItem("token")) {
      // if (
      //   localStorage.getItem("token") &&
      //   localStorage.getItem("token") == "xxx"
      // ) {
      //   localStorage.setItem("token", "");
      // }
      localStorage.setItem("pageType", "bate");
      if (localStorage.getItem("token")) {
        this.$router.push("/home");
        this.$router.go();
        this.isShow = false;
      } else {
        this.$router.push("/home");
        this.isShow = false;
      }

      // }
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/pages/wecome/wecome.vue